<template>
    <span>
        <v-tooltip bottom color="#000000DE" max-width="300px" v-if="text">
            <template v-slot:activator="{ on, attrs }">
                <span
                    class="small-hint"
                    v-bind="attrs"
                    v-on="on"
                    :style="hintStyle"
                >?</span>
            </template>
            <span class="white--text">{{ text }}</span>
        </v-tooltip>
    </span>
</template>

<script>
export default {
    name: 'HintIcon',
    props: {
        text: {
            type: String,
            default: null,
        },
        size: {
            type: Number,
            default: 14,
        },
        color: {
            type: String,
            default: null,
        },
        noOpacity: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        hintStyle() {
            const scale = this.size / 14
            return {
                width: `${this.size}px`,
                height: `${this.size}px`,
                fontSize: `${Math.max(8, Math.round(8 * scale))}px`,
            }
        },
    },
}
</script>

<style lang="sass" scoped>
@import '@/vars.sass'

.small-hint
    border-radius: 50%
    background: rgba(26, 32, 64, .06)
    cursor: pointer
    color: $muted-new
    display: inline-flex
    align-items: center
    justify-content: center
    padding: 0
    line-height: 1
    font-family: $font-family-base
    font-weight: 600
    flex-shrink: 0
    transition: background-color .15s ease, color .15s ease, transform .1s ease

    &:hover
        background: rgba($text-color-new, .12)
        color: $text-color-new

    &:active
        background: rgba($text-color-new, .16)
        transform: translateY(1px)

    &:focus-visible
        outline: 2px solid rgba($main-new, .35)
        outline-offset: 1px
</style>
